export default "__VITE_ASSET__D$ytiRVZ__"